<template>
  <div class="locMain">

    <div class="locColumn">
      <InputQuery placeholder="Pick Up" :isRequired="true" :items="data['rotPickup']" itemKey="Destination Code" descKey="Company"
                :selectedObject.sync="data['PickUp']" :isDisabled="data['mode'] == 'V'" :errorMessage.sync="data['rotErrors']['pickup']"/>
      
        <div class="rowItems">
          <InputQuery style="width: 100%;" placeholder="Send To" :isRequired="true" :items="data['rotSendto']" itemKey="Destination Code" descKey="Company"
                  :selectedObject.sync="data['SendTo']" @selected="sendToChange" :isDisabled="data['mode'] == 'V'" :errorMessage.sync="data['rotErrors']['sendto']"/>
          <CheckBox class="showAllCheck" :isChecked.sync="data['ShowAll']" title="Show All" @checkBoxClicked="checkBoxClicked('showall')" :isDisabled="data['ShowAll'] || data['mode'] == 'V'"/>
        </div>
      <InputQuery placeholder="Tariff Area" :isRequired="true" :items="data['rotSendto']" itemKey="Tariff Area" descKey=""
            :selectedObject.sync="data['TariffArea']" :isDisabled="true" :errorMessage.sync="data['rotErrors']['tariffarea']"/>

      <div class="addressBox">
        <div class="rowItems">
          <Input placeholder="Post Code" :inputValue.sync="data['PostCode']" :isDisabled="true"/>
          <Input placeholder="Zone" :inputValue.sync="data['Zone']" :isDisabled="true"/>
        </div>
          
        <div class="rowItems">
          <Input placeholder="Attention" :inputValue.sync="data['Attention']" :isDisabled="true"/>
          <Input placeholder="Tel No" :inputValue.sync="data['TelNo']" :isDisabled="true"/>
        </div>

        <div class="addressTextAreaMain">
          <div class="addressTextAreaTitle"> Address </div>
          <textarea class="addressTextArea" v-model="data['Address']" :disabled="data['mode'] == 'V'"/>
        </div>
      </div>
    </div>

    <div class="locColumn">
      <InputQuery placeholder="Drop Off" :isRequired="true" :items="data['rotDropoff']" itemKey="Destination Code" descKey="Company"
                :selectedObject.sync="data['Dropoff']" :isDisabled="data['mode'] == 'V'" :errorMessage.sync="data['rotErrors']['dropoff']"/>
      <Dropdown placeholder="Trip" :isRequired="true" :items="data['rotTrips']" :selectedObject.sync="data['Trip']"
          :isDisabled="data['mode'] == 'V'" :errorMessage.sync="data['rotErrors']['trip']"/>
    </div>

    <div class="locColumn">
      <div class="rowItems">
        <DateTime class="rowItem" title="Required" :value.sync="data['Required']" :isDisabled="data['mode'] == 'V'"/>
        <DateTime class="rowItem" title="To" :value.sync="data['To']" :isDisabled="data['mode'] == 'V'"/>
      </div>
      <div class="rowItems">
        <Input class="rowItem" placeholder="Desc" :inputValue.sync="data['Desc']" :isDisabled="data['mode'] == 'V'"/>
        <CheckBox class="rowItem" :isChecked.sync="data['OfficeHours']" title="Office Hours" @checkBoxClicked="checkBoxClicked('')" :isDisabled="true"/>
      </div>
      
      <Input placeholder="Ability to accept No of cont." :inputValue.sync="data['AbilityNoCont']" :isDisabled="data['mode'] == 'V'"/>
      <Input placeholder="Time needed to unstuff / stuff" :inputValue.sync="data['TimeNeeded']" :isDisabled="data['mode'] == 'V'"/>
      <CheckBox :isChecked.sync="data['Offload']" title="Offload at Premises" @checkBoxClicked="checkBoxClicked('')" :isDisabled="data['mode'] == 'V'"/>
       
    </div>

    <Loader :isVisible="loadShow" :loadingText="loadText" />

  </div>
</template>

<script>
/* eslint-disable */
import Menu from '@/components/Menus.vue';
import Tabulator from '@/components/Tabulator.vue';
import EntryPopup from '@/components/EntryPopup.vue';
import TabView from '@/components/TabView.vue';
import Input from '@/components/Input.vue';
import InputQuery from '@/components/InputQuery.vue';
import DateTime from '@/components/DateTimePicker.vue';
import Dropdown from '@/components/Dropdown.vue';
import CheckBox from '@/components/CheckBox.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'loc',
  components: {
    Menu, Tabulator, EntryPopup, Input, InputQuery, DateTime, Dropdown, CheckBox, TabView, Loader
  },
  data: function() {
    return {
    }
  },
  props: {
    //-------- Main Props
    data: { type: Object, default: function () { return {} } },
    viewMode: { type: Boolean, default: false },

    //-------- Load Props
    loadShow: { type: Boolean, default: false },
    loadText: { type: String, default: 'Loading' },
  },
  mounted() {  },
  methods: {
    sendToChange: async function(obj) {
      // console.log(obj);
      if (obj) {
        var tariff = this.data['rotSendto'].filter((s) => { return s['Tariff Area'] == obj['Tariff Area'] });
        if (tariff.length > 0) { this.$set(this.data, 'TariffArea', tariff[0]); }

        var testTime = new Date();
        // Get Post Code, Zone, etc..
        try {
          testTime = new Date();
          var sendToDetails = await this.$apiCallV2('/ROT/GetListMaster?master=sendto_details?destCode=' + obj['Destination Code']);
          console.log('%cSend To Details', 'color: lightgreen;', sendToDetails);
          var sendToDetailsF = [];
          if (Array.isArray(sendToDetails)) { sendToDetails.forEach((r) => { sendToDetailsF.push(r); }); }
          // this.$set(this.rotPersistentData, 'rotRemarks', rotRemarksF);
          console.log('%cDuration', 'color: yellow;', (new Date() - testTime) + ' ms');
        } catch (e) { console.log(e); }

        // Set other data such as Post Code, Zone, etc..
        this.$set(this.data, 'PostCode', this.data['PostCode'] ? this.data['PostCode'] : obj['PostCode'] ? obj['PostCode'] : '');
        this.$set(this.data, 'Zone', this.data['Zone'] ? this.data['Zone'] : obj['Zone'] ? obj['Zone'] : (obj['ZoneType'] ? obj['ZoneType'] : ''));
        this.$set(this.data, 'TelNo', this.data['TelNo'] ? this.data['TelNo'] : obj['Tel No'] ? obj['Tel No'] : '');
        this.$set(this.data, 'Attention', this.data['Attention'] ? this.data['Attention'] : obj['Contact'] ? obj['Contact'] : '');

        this.$set(this.data, 'Desc', this.data['Desc'] ? this.data['Desc'] : obj['Default Required Time Desc'] ? obj['Default Required Time Desc'] : '');
        this.$set(this.data, 'OfficeHours', this.data['OfficeHours'] ? (this.data['OfficeHours'].trim() == '24 Hours' ? true : false) : obj['Office Hours'] ? (obj['Office Hours'].trim() == '24 Hours' ? true : false) : false);
      }
    },
    checkBoxClicked: async function(box) {
      switch(box) {
        case 'showall':

          this.loadShow = true;

          //-------- SendTo
          try {
            this.$set(this.data, 'rotSendto', []); 
            this.$set(this.data, 'SendTo', null); 
            this.$set(this.data, 'TariffArea', null); 
            // this.$set(this.data, 'rotSendtoRaw', []);

            this.loadText = 'Getting Send To Destinations';
            var rotSendto =  rotSendto = await this.$apiCallV2('/ROT/GetListMaster?master=sendto_all&custNo=' + this.data['CustCode']);
            console.log('%cSendTo Data', 'color: hotpink;', rotSendto);
            var rotSendtoF = [];
            if (Array.isArray(rotSendto)) { rotSendto.forEach((s) => { rotSendtoF.push(s); }); }
            this.$set(this.data, 'rotSendto', rotSendtoF);
            // this.$set(this.data, 'rotSendtoRaw', rotSendto['data']);
          } catch (e) { console.log(e); }
          
          this.loadShow = false; this.loadText = 'Loading'; 
          break;
      }
    },
  },
  watch: {

  },
}
</script>

<style lang="scss" scoped>
  @import '@/css/all.scss';

  .locMain {
    width: 100%;
    height: auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .locColumn {
    width: auto;
    height: 100%;
    padding: 0 4px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
  }
  
  .addressBox {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .rowItems {
    width: 100%;
    height: auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .rowItems * {
    width: 49%;
  }

  .showAllCheck {
    width: auto;
    position: absolute;
    padding: 0 0 0 10px;
    right: 0px;
    background-color: white;
  }

  .addressTextAreaMain {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  
  .addressTextAreaTitle {
    width: 100%;
    height: auto;
    padding: 0 0 0 10px;
    font-size: 12px;
    color: gray;
    user-select: none;
  }

  .addressTextArea {
    width: 100%;
    height: auto;
    min-height: 80px;
    border: solid 1px lightgray;
    resize: none;
    transition: 0.3s;
  }

  .addressTextArea:focus {
    border: solid 1px gray;
    outline: none;
  }

</style>